export default [
  {
    path: "collections",
    name: "collections",
    component: () => import("../../views/collections/index.vue"),
    meta: {
      permission: "show_all_collections",
    },
  },
  {
    path: "collection/create",
    name: "create_collection",
    component: () => import("../../views/collections/create.vue"),
    meta: {
      permission: "create_collections",
    },
  },
  {
    path: "collections/:id",
    name: "show_collection",
    component: () => import("../../views/collections/show.vue"),
    meta: {
      permission: "show_single_collections",
    },
  },
  {
    path: "collection-approvals",
    name: "collection-approvals",
    component: () => import("../../views/collections/approvals.vue"),
    meta: {
      permission: "create_approve_collection",
      label: "Collection Approvals",
    },
  },
];
